// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/styles/index.scss' // global css
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'view-design/dist/styles/iview.css'
import 'github-markdown-css/github-markdown.css'
import { Modal } from 'view-design'
import '@/assets/js/jquery.min.js'
import '@/assets/js/xhome.js'
Vue.component('Modal', Modal)
ElementUI.Dialog.props.lockScroll.default = false;

Vue.use(ElementUI)
Vue.config.productionTip = false
if(XHOME.browser.isMobile==true){
  $('body').addClass('mobile');
}else{
  $('body').removeClass('mobile');
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js